module.exports = __webpack_public_path__ + "static/playground-22bf11c6edbc3fdebfdd1d8c80d5e2c7.webm";